import { render, staticRenderFns } from "./compDoctorsComboBox.vue?vue&type=template&id=064740bc&scoped=true"
import script from "./compDoctorsComboBox.vue?vue&type=script&lang=js"
export * from "./compDoctorsComboBox.vue?vue&type=script&lang=js"
import style0 from "./compDoctorsComboBox.vue?vue&type=style&index=0&id=064740bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064740bc",
  null
  
)

export default component.exports